import React from "react";

//libs
import { useState } from "react";
import { DialogTitle } from "@headlessui/react";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";
import Loading from "components/Loading";
//hooks
import {
  useQuotationCreateQuestion,
  useTenderCreateQuestion,
} from "hooks/api/useQuestionsAndAnswers";

export default function AddQuestionModal({
  isTender,
  tenderId,
  open,
  setOpen,
}: {
  isTender: boolean;
  tenderId: number;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const useCreateQuestion = isTender
    ? useTenderCreateQuestion
    : useQuotationCreateQuestion;
  const { mutate, isPending } = useCreateQuestion(tenderId);

  const [question, setQuestion] = useState("");

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      mutate(question);
      setOpen(false);
      setQuestion("");
    } catch (err) {}
  };

  return (
    <ModalDialog open={open} setOpen={setOpen}>
      <div className="space-y-4">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Ask Questions
        </DialogTitle>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="">
            <label
              htmlFor="question"
              className="block text-base font-medium leading-6 text-gray-900"
            >
              Your Question
            </label>
            <div className="mt-2">
              <textarea
                autoFocus
                id="question"
                name="question"
                rows={4}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </div>
          </div>
          <div className="sm:flex gap-2">
            <Button disabled={isPending} type="submit">
              <Loading text="Add" isLoading={isPending} />
            </Button>
            {/* <button
              disabled={isPending}
              type="button"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
            >
              <Loading text="Add And Another" isLoading={isPending} />
            </button> */}
            <button
              type="button"
              data-autofocus
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </ModalDialog>
  );
}
